import {apiPost} from './api';

export default class ServicioLaboratorio {
  static cargaCodigo(codigoBarras) {
    return apiPost('/laboratorio/codigobarras/CargarMuestra', {
      CodigoBarras: codigoBarras,
    });
  }
  static extraccionCodigo(codigoBarras) {
    return apiPost('/laboratorio/codigobarras/Extraccion', {
      CodigoBarras: codigoBarras,
    });
  }
  static antigenosCodigo(codigoBarras) {
    return apiPost('/laboratorio/codigobarras/Antigenos', {
      CodigoBarras: codigoBarras,
    });
  }
  static anticuerposCodigo(codigoBarras) {
    return apiPost('/laboratorio/codigobarras/Anticuerpos', {
      CodigoBarras: codigoBarras,
    });
  }
  static rapidasCodigo(codigoBarras) {
    return apiPost('/laboratorio/codigobarras/PruebasRapidas', {
      CodigoBarras: codigoBarras,
    });
  }
  static prePCRCodigo(codigoBarras, pcrID) {
    return apiPost('/laboratorio/codigobarras/Pre-PCR', {
      CodigoBarras: codigoBarras,
      PCRID: pcrID,
    });
  }
  static cargarMuestras(muestras) {
    const data = {
      CargarMuestras: muestras,
    };
    return apiPost('/laboratorio/CargarMuestras', data);
  }
  static extraccionMuestras(extraccionTipoID, muestras) {
    const data = {
      ExtraccionTipoID: extraccionTipoID,
      ExtraccionMuestras: muestras,
    };
    return apiPost('/laboratorio/Extraccion', data);
  }
  static antigenosResultado(muestras) {
    const data = {
      AntigenosMuestras: muestras,
    };
    return apiPost('/laboratorio/Antigenos', data);
  }
  static anticuerposResultado(muestras) {
    const data = {
      AnticuerposMuestras: muestras,
    };
    return apiPost('/laboratorio/Anticuerpos', data);
  }
  static rapidasResultado(muestras) {
    const data = {
      PruebasRapidasMuestras: muestras,
    };
    return apiPost('/laboratorio/PruebasRapidas', data);
  }
  static reporteMuestras(filtros) {
    return apiPost('/laboratorio/reporte/Muestras', filtros);
  }
  static reportePCR(filtros) {
    return apiPost('/laboratorio/reporte/PCR', filtros);
  }
  static guardarPrePCR(kitID, muestras) {
    const data = {
      KitID: kitID,
      PrePCRMuestras: muestras,
    };
    return apiPost('/laboratorio/PrePCR', data);
  }
  static actualizarPrePCR(kitID, muestras, pcrID) {
    const data = {
      KitID: kitID,
      PrePCRMuestras: muestras,
      PCRID: pcrID,
    };
    return apiPost('/laboratorio/PrePCR/Actualizar', data);
  }
  static procesarPCR(archivoCSV, pcrID) {
    const data = {
      PCRID: pcrID,
      ArchivoCSV: archivoCSV,
    };
    return apiPost('/laboratorio/ProcesarPCR', data);
  }
  static validacionPCR(pcrID) {
    const data = {
      PCRID: pcrID,
    };
    return apiPost('/laboratorio/PCRValidacion', data);
  }
  static guardarValidarPCR(pcrID, muestrasCambiadas) {
    const data = {
      PCRID: pcrID,
      PCRMuestras: muestrasCambiadas,
    };
    return apiPost('/laboratorio/PCR', data);
  }
  static infoMuestra(muestraDetalleID) {
    const data = {
      MuestraDetalleID: muestraDetalleID,
    };
    return apiPost('/laboratorio/InfoMuestra', data);
  }

  static resultadosPCR(pcrID) {
    const data = {
      PCRID: pcrID,
    };
    return apiPost('/laboratorio/PCRResultado', data);
  }
  static getInterpretacion(muestra) {
    return apiPost('/laboratorio/PruebasRapidasInterpretacion', muestra);
  }
  static getPrePCRResultado(pcrID) {
    const data = {
      PCRID: pcrID,
    };
    return apiPost('/laboratorio/PrePCRResultado', data);
  }
  static regresarEstatus(pcrID) {
    const data = {
      PCRID: pcrID,
    };
    return apiPost('/laboratorio/PCR/RegresarEstatusAnterior', data);
  }
  static procesarPCRManual(pcrID, pw) {
    const data = {
      PCRID: pcrID,
      Password: pw,
    };
    return apiPost('/laboratorio/ProcesarPCRManual', data);
  }
}
